import { apiClient } from "./client";

export interface ClientForecast {
  hour: number;
  client_code: string;
  forecast_kwh: number | string;
}

export const forecastsApi = {
  list: (date: string) =>
    apiClient.get<ClientForecast[]>(`/forecasts/${date}`).then((r) => r.data),

  put: (date: string, hour: number, client_code: string, forecast_kwh: number) =>
    apiClient
      .put<ClientForecast>(`/forecasts/${date}/hour/${hour}/${client_code}`, {
        forecast_kwh,
      })
      .then((r) => r.data),

  delete: (date: string, hour: number, client_code: string) =>
    apiClient.delete(`/forecasts/${date}/hour/${hour}/${client_code}`),
};
